export const modes = {
  ADD: 'add',
  EDIT: 'edit',
  READONLY: 'readonly',
}
